import { Autocomplete, Box, TextField } from "@mui/material";
import React from "react";
import {TEXT_FIELD_STYLE} from "../../constants/Styles";
import ReactQuill from "react-quill";
import 'react-quill/dist/quill.snow.css';

export const StyledTextField = ({
  children,
  textFieldStyle = {},
  InputProps,
  ...props
}) => (
  <TextField
    fullWidth
    margin="dense"
    variant="outlined"
    InputProps={{
      style: { ...TEXT_FIELD_STYLE, ...textFieldStyle },
      ...InputProps
    }}
    {...props}
  >{children}</TextField>
)

export const StyledMultilineTextField = ({
  children,
  textFieldStyle = {},
  ...props
}) => (
 <TextField
    fullWidth
    margin="dense"
    variant="outlined"
    multiline
    rows={5}
    InputProps={{
      style: { ...TEXT_FIELD_STYLE, ...textFieldStyle }
    }}
    {...props}
  >{children}</TextField>
)

export const StyledRichTextEditor = ({
  value,
  onChange
}) => (
  <ReactQuill theme="snow" value={value} onChange={onChange} />
)

export const StyledAutocomplete = ({
  options,
  onChange,
  value,
  ...props
}) => (
  <Autocomplete
      disablePortal
      options={options}
      fullWidth
      value={value}
      onChange={onChange}
      renderInput={(params) => <StyledTextField {...props} {...params}/>}
    />
)

const defaultModules = {
  toolbar: [
    [{ header: [1, 2, 3, 4, false] }],
    ['bold', 'italic', 'underline', 'strike'],
    [{ list: 'ordered' }, { list: 'bullet' }],
    ['link', 'code-block'],
    ['clean'],
  ],
};

export const StyledRichTextbox = ({
  value,
  onChange,
  placeholder = 'Write your notes here…',
  modules = defaultModules,
  minHeight = 200,
}) => {
  return (
    <Box
      sx={{
        border: '1px solid #ddd',
        borderRadius: 2,
        overflow: 'hidden',
        backgroundColor: '#fff',

        /* Toolbar styling */
        '& .ql-toolbar': {
          border: 'none',
          borderBottom: '1px solid #e0e0e0',
          backgroundColor: '#fafafa',
        },

        /* Editor container */
        '& .ql-container': {
          border: 'none',
          fontFamily: 'inherit',
        },

        '& .ql-editor': {
          minHeight,
          padding: 2,

          '& h1': { fontSize: '1.9rem', fontWeight: 600, marginTop: '16px', marginBottom: '8px' },
          '& h2': { fontSize: '1.4rem', fontWeight: 600, marginTop: '16px', marginBottom: '8px' },
          '& h3': { fontSize: '1.15rem', fontWeight: 600, marginTop: '12px', marginBottom: '6px' },
          '& h4': { fontSize: '1rem', fontWeight: 500, marginTop: '10px', marginBottom: '4px' },
          '& h5': { fontSize: '0.9rem', fontWeight: 500, marginTop: '8px', marginBottom: '4px' },
          '& p': { fontSize: '0.95rem', lineHeight: 1.6, marginBottom: '8px' },
          '& ul, & ol': { fontSize: '0.95rem', paddingLeft: '24px' },

          '& code': {
            fontSize: '0.85rem',
            backgroundColor: '#f5f5f5',
            padding: '2px 6px',
            borderRadius: '4px',
            fontFamily: 'monospace',
          },
        },
      }}
    >
      <ReactQuill
        value={value}
        onChange={onChange}
        modules={modules}
        placeholder={placeholder}
        theme="snow"
      />
    </Box>
  );
};
